function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class RawFetchCache {
    addStatefulPromise(key, statefulPromise) {
        this.fetchMap.set(key, statefulPromise);
        this.notifyObservers(key);
    }
    getStatefulPromise(key) {
        return this.fetchMap.get(key);
    }
    subscribe(key, observer) {
        if (!this.observers.has(key)) {
            this.observers.set(key, new Set());
        }
        this.observers.get(key).add(observer);
        return ()=>{
            const observers = this.observers.get(key);
            if (observers) {
                observers.delete(observer);
                if (observers.size === 0) {
                    this.observers.delete(key);
                    this.fetchMap.delete(key);
                }
            }
        };
    }
    notifyObservers(key) {
        const observers = this.observers.get(key);
        if (observers) {
            observers.forEach((observer)=>observer());
        }
    }
    constructor(){
        _define_property(this, "fetchMap", void 0);
        _define_property(this, "observers", void 0);
        this.fetchMap = new Map();
        this.observers = new Map();
    }
}
export { RawFetchCache as default };

//# sourceMappingURL=RawFetchCache.js.map